import { get } from 'lodash';

export const extractFieldIdentifier = ({ fields, field, id, uuid }) => {
  if(!field && id) {
    field = get(fields, `byId.${id}`, null);
  }

  if(!field && uuid) {
    field = get(fields, `byUuid.${uuid}`, null);
  }

  return {
    field,
    uuid: uuid || get(field, 'uuid', null),
    id: `${id || get(field, 'id', '')}` || null // id as string unless not found, then null
  };
};

export const addOperationIdsToFields = ({ operations, fields }) => {
  // TODO: Move this operation state awareness into an extractor/transformer for operations
  const operationsByOwnerId = Object.values(operations).reduce( (byOwnerId, operation) => {
    if (operation) {
      byOwnerId[operation.operationOwnerId] = operation;
    }
    return byOwnerId;
  }, {});

  Object.values(fields.byId).forEach( field => {
    if (fields.byId[field.id] && operationsByOwnerId[field.userId]) {
      fields.byId[field.id].operationId = operationsByOwnerId[field.userId].operationId;
    }
  });
  return fields;
};
